<template>
  <EditorPickLotteryQuickPickCard
    v-model:random="isRandom"
    body-class="pt-300"
    :headline="$t('picklottery.quickpick.numbers.headline')"
  >
    <LcDigitInputGroup
      ref="inputGroup"
      v-bind="{ errorMessage }"
      v-slot="{ setRef }"
      class="flex flex-col items-center"
      feedback-message-class="text-center"
      :value="selectedNumbers"
      wrapper-class="justify-center gap-100"
    >
      <LcDigitInput
        v-for="({ name }, index) in config.numbers"
        v-bind="{ index }"
        :key="name"
        :ref="setRef"
        :disabled="disabledFields.includes(name)"
        @click="inputGroupRef?.focusInputByIndex(index)"
        @update:value="(newValue) => handleSetNumber(index, newValue)"
      />
    </LcDigitInputGroup>

    <LcInfoText v-if="config.isLockoutLottery" class="mt-100 text-secondary-secondary" size="small">
      {{ $t('picklottery.disclaimer.lockoutlottery') }}
    </LcInfoText>
  </EditorPickLotteryQuickPickCard>
</template>

<script lang="ts" setup>
import type { Config } from '../@types/editor'

type Props = {
  config: Config
  disabledFields?: string[]
  errorMessage?: string
}

const { config, disabledFields = [] } = defineProps<Props>()

const numbers = defineModel<Maybe<Maybe<number>[]>>('value', { required: true })

const inputGroupRef = useTemplateRef('inputGroup')

const isRandom = computed({
  get: () => !numbers.value,
  set: (random) => (numbers.value = random ? null : []),
})

const selectedNumbers = computed(() => numbers.value ?? [])

const handleSetNumber = (index: number, newValue: Maybe<number>) => {
  const updated = [...selectedNumbers.value]
  while (updated.length <= index) updated.push(null)
  updated[index] = newValue ?? null

  numbers.value = updated
}
</script>
